import { FilterCategory, FilterItem } from '../../services/types/services'

export const extractRangeFilters = (filters: FilterItem[]) => {
  return filters
    .filter(
      (filter): filter is FilterCategory =>
        filter.__typename === 'FilterCategory' &&
        filter.useAgeInputField === true,
    )
    .map(filter => ({
      name: filter.id,
      value: undefined,
    }))
}
